import React from 'react';
import _ from 'lodash';

import Information from './common/Information';
import { ConstructionPermitTable } from '../tables/ConstructionPermitTable';
import { FormList, FormListItem } from '../CommonFormComponents';
import { ATTACH_DOCUMENT_TYPE_COMPANY } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

/**
 * error dialog with duplicate when creating license from ccus
 * @param dialog {object}
 * @returns {JSX.Element}
 */
export const CreateFromLicenseCcusErrorDialog = ({ dialog }) => {
  const {
    ccusLicense,
    duplicateLicenses,
    documentCodes,
    bureaux,
    callback,
  } = dialog;

  const renderDuplicateLicense = () => {
    return (
      <React.Fragment>
        <FormListItem isBorder={false}>
          <div className='form-list__item-title'>Buildee登録済み許可情報</div>
        </FormListItem>
        <FormListItem isBorder={false}>
          <ConstructionPermitTable
            data={duplicateLicenses}
            isCcusMode={false}
            readOnly={true}
            documentCodes={_.filter(
              documentCodes,
              document =>
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.CONSTRUCTION_PERMISSION
            )}
            bureaux={bureaux}
            download={callback.onDownload}
          />
        </FormListItem>
      </React.Fragment>
    );
  };

  const renderCcusLicense = () => {
    return (
      <React.Fragment>
        <FormListItem isBorder={false}>
          <div className='ccus-title'>転記する許可情報</div>
        </FormListItem>
        <FormListItem isBorder={false}>
          <ConstructionPermitTable
            data={[ccusLicense]}
            isCcusMode={true}
            readOnly={true}
            documentCodes={_.filter(
              documentCodes,
              document =>
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.CONSTRUCTION_PERMISSION
            )}
            bureaux={bureaux}
            download={callback.onDownload}
          />
        </FormListItem>
      </React.Fragment>
    );
  };

  const renderMessage = () => {
    return (
      <FormList>
        <FormListItem isBorder={false}>
          下記のBuildee登録済み許可情報と重複してしまうため、転記ができませんでした。
          <br />
          許可情報を削除、または修正したうえで、再度転記操作を行ってください。
        </FormListItem>
        {renderDuplicateLicense()}
        {renderCcusLicense()}
      </FormList>
    );
  };

  return (
    <Information
      title='転記できませんでした'
      visible={true}
      rootClassName='ErrorDialogCreateFromLicenseCcus'
      buttonText={messageUtility.getMessage('I-000-017')}
      message={renderMessage()}
      multilineText={true}
      onClose={() => _.isFunction(callback.onClose) && callback.onClose()}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/CreateFromLicenseCcusErrorDialog.jsx